import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from "react-select";

import TooltipIcon from "@/views/components/TooltipIcon/TooltipIcon";

import styles from '@/views/components/CustomSelect/CustomSelect.module.scss';

const colourStyles = {
	container: styles => ({ ...styles, width: '100%' }),
	control: styles => ({ ...styles, borderColor: '#DADADA', maxHeight: '35px', height: '35px', borderRadius: '16px', minHeight: '0', boxShadow: 'none' }),
	valueContainer: styles => ({ ...styles, maxHeight: '35px', height: '35px', borderRadius: '16px', padding: '0 5px 0 10px' }),
	indicatorsContainer: styles => ({ ...styles, maxHeight: '35px', height: '35px' }),
	singleValue: styles => ({ ...styles, fontSize: '0.8125rem' }),
	placeholder: styles => ({ ...styles, fontSize: '0.8125rem', color: '#B1B1B1' }),
};

export const Option = (props) => {
	return (
		<components.Option { ...props }>
			<div style={ { display: 'flex', flexDirection: 'row' } }>
				{props.isSelected && <div className='icon-accept' />}
				{props.data.label}
			</div>
		</components.Option>
	);
};
export const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator { ...props }>
			<div className='icon-arrow-down-full arrow' />
		</components.DropdownIndicator>
	);
};
export const ClearIndicator = props => {
	return (
		<components.ClearIndicator { ...props }>
			<div className={ styles[`custom-select--clear`] }>
				<i className='icon-close icon' />
			</div>
		</components.ClearIndicator>
	);
};

export const NoOptionsMessage = props => {
	return (
		<components.NoOptionsMessage { ...props }>
			<span>Brak elementów</span>
		</components.NoOptionsMessage>
	);
};

const CustomSelect = ({
	label = undefined,
	tooltipText = undefined,
	options, value,
	onChange,
	onInputChange = undefined,
	placeholder,
	inline,
	isClearable,
	formInput = false,
	defaultValue = null,
	disabled = false,
}) => {
	const [ isMenuOpened, setIsMenuOpened ] = useState(false);

	return (
		<div className={ styles[`custom-select--container${inline ? '-inline' : ''}`] }>
			{label &&
			<label className={ styles[`custom-select--label${inline ? '-inline' : ''}`] }>
				{label}
				{tooltipText && <TooltipIcon
					color="#0066D3"
					tooltipText={ tooltipText }
				/>}
			</label>
			}
			<Select
				isClearable={ isClearable }
				options={ options }
				value={ value }
				defaultValue={ defaultValue }
				styles={ colourStyles }
				onChange={ onChange }
				onInputChange={ onInputChange }
				placeholder={ placeholder }
				className={  isMenuOpened ? 'custom-select--filters-select--menu-opened' : ''  }
				classNamePrefix={ formInput ? 'custom-select--filters-select-form' : 'custom-select--filters-select' }
				components={ {
					IndicatorSeparator: () => null,
					DropdownIndicator,
					ClearIndicator,
					NoOptionsMessage,
					Option,
				} }
				onMenuOpen={ () => setIsMenuOpened(true) }
				onMenuClose={ () => setIsMenuOpened(false) }
				fullwidth
				isDisabled={ disabled }
			/>
		</div>
	);
};
CustomSelect.propTypes = {
	options: PropTypes.array,
	value: PropTypes.any,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	formInput: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default memo(CustomSelect);
